import React, { useState, useEffect } from 'react';
import { useAssetContext } from '../contexts/AssetContext';
import AssetTable from './AssetTable';
import SyncButton from './SyncButton';

const Dashboard = () => {
  const { state } = useAssetContext();
  const [filteredAssets, setFilteredAssets] = useState([]);
  const [filter, setFilter] = useState('all');

  // Filter assets based on selected exchange
  useEffect(() => {
    if (filter === 'all') {
      setFilteredAssets(state.assets);
    } else {
      setFilteredAssets(state.assets.filter(asset => asset.source === filter));
    }
  }, [state.assets, filter]);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-gray-800">Portfolio Dashboard</h2>
        <SyncButton />
      </div>
      
      {state.lastUpdated && (
        <div className="text-sm text-gray-500">
          Last updated: {new Date(state.lastUpdated).toLocaleString()}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-lg font-medium text-gray-700">Total Assets</h3>
          <p className="text-2xl font-bold text-gray-900">
            ${state.assets.reduce((sum, asset) => sum + (asset.value || 0), 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </p>
        </div>
        
        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-lg font-medium text-gray-700">Exchanges</h3>
          <p className="text-2xl font-bold text-gray-900">
            {Object.keys(state.exchanges).filter(ex => state.exchanges[ex].enabled).length}
          </p>
        </div>
        
        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-lg font-medium text-gray-700">Assets</h3>
          <p className="text-2xl font-bold text-gray-900">{state.assets.length}</p>
        </div>
        
        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-lg font-medium text-gray-700">Status</h3>
          <p className={`text-2xl font-bold ${state.loading ? 'text-yellow-500' : 'text-green-500'}`}>
            {state.loading ? 'Updating...' : 'Up to date'}
          </p>
        </div>
      </div>

      <div className="bg-white p-4 rounded-lg shadow">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-medium text-gray-700">Assets</h3>
          <div className="flex space-x-2">
            <select
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              className="border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="all">All Sources</option>
              <option value="binance">Binance</option>
              <option value="okx">OKX</option>
              <option value="hyperliquid">Hyperliquid</option>
              <option value="aster">Aster</option>
              <option value="defi">DeFi</option>
            </select>
          </div>
        </div>
        <AssetTable assets={filteredAssets} />
      </div>
    </div>
  );
};

export default Dashboard;